var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 9.89 13.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4{fill:#1c3152;}.cls-3{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 9.89,
    height: 13.38
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.36,5.83l-.24-.25a.67.67,0,0,1,0-1,.73.73,0,0,1,1,0l1,1,.52.53a.79.79,0,0,1,0,1.06c-.5.51-1,1-1.51,1.54A.73.73,0,0,1,6.9,8.33a.69.69,0,0,1,.23-.57,2.8,2.8,0,0,0,.23-.24H7.13c-.94,0-1.89,0-2.83,0A.82.82,0,0,1,3.49,7a.78.78,0,0,1,.17-.88.84.84,0,0,1,.68-.27h3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.43,11.17H2.24v-9H5.45A1.1,1.1,0,0,0,6.52,1.09,1,1,0,0,0,6.2.33,1.06,1.06,0,0,0,5.43,0H1.14A1.07,1.07,0,0,0,.39.34a1.09,1.09,0,0,0-.32.76V12.27A1,1,0,0,0,.39,13a1.07,1.07,0,0,0,.77.32H5.45a1.09,1.09,0,0,0,0-2.17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.2eb661d211d1553b7515a373c5297cc5.svg";
export { ForwardRef as ReactComponent };